"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputs = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const colors_1 = require("../basic/colors");
const spaces_1 = require("../basic/spaces");
const media_1 = require("../basic/media");
const icons_1 = require("../basic/icons");
exports.inputs = (0, basic_1.applyBase)({
    numericControlWrap: {
        display: 'flex',
        flexShrink: '0',
        width: ['120px', '135px'],
        justifyContent: 'space-between',
        '.input': Object.assign({ p: '0px', background: 'transparent', width: '25px', textAlign: 'center', mx: '13px' }, font_faces_1.FONT_SIZE.LARGE_BOLD),
    },
    numericControl: {
        p: 0,
        color: 'black',
        '.icon': {
            height: ['30px', '38px'],
            width: ['30px', '38px'],
        },
        letterSpacing: 'initial',
        ':disabled': {
            opacity: 0.3,
            '&:hover, &:focus': {
                color: 'initial',
            },
        },
    },
    baseInput: Object.assign(Object.assign({ border: '1px solid', borderColor: 'borderColor', bg: 'bgInput', borderRadius: '0px', width: '100%', py: 2, px: ['12px', '20px'] }, font_faces_1.FONT_SIZE.LARGE), { height: '50px', '::placeholder': {
            color: colors_1.colors.secondary,
        }, letterSpacing: 'inherit', ':disabled': {
            background: colors_1.colors.lightGreyFirst,
            cursor: 'default',
        } }),
    baseInputIcon: {
        left: ['14px', '20px'],
    },
    hasIconMargin: {
        pl: ['44px', '52px'],
    },
    select: Object.assign(Object.assign({ border: '1px solid', borderColor: colors_1.colors.borderColor, borderRadius: 0, background: colors_1.colors.bgInput, width: '100%' }, font_faces_1.FONT_SIZE.LARGE), { paddingTop: ['13px', '11px'], paddingBottom: ['13px', '11px'], paddingLeft: ['10px', '13px'], paddingRight: spaces_1.space[5], appearance: 'none', color: 'inherit', '::-ms-expand': {
            display: 'none',
        } }),
    error: {
        '.status-icon': Object.assign({ color: colors_1.colors.primary, right: '35px', left: 'auto', top: 'auto', bottom: '1px' }, icons_1.icons.lg),
        '.input': {
            borderColor: colors_1.colors.error,
            paddingLeft: '12px',
            paddingRight: '45px',
            '~ .icon': Object.assign({ color: colors_1.colors.error, right: '15px', left: 'auto' }, icons_1.icons.lg),
            [media_1.media.tablet]: {
                paddingLeft: '20px',
                paddingRight: '52px',
                '~ .icon': {
                    right: '20px',
                },
            },
        },
    },
    success: {
        '.status-icon': Object.assign({ color: colors_1.colors.success, right: '35px', left: 'auto', top: 'auto', bottom: '1px' }, icons_1.icons.lg),
        '.input': {
            borderColor: colors_1.colors.success,
            paddingLeft: '12px',
            paddingRight: '45px',
            '~ .icon': Object.assign({ color: colors_1.colors.success, right: '15px', left: 'auto' }, icons_1.icons.lg),
            [media_1.media.tablet]: {
                paddingLeft: '20px',
                paddingRight: '52px',
                '~ .icon': {
                    right: '20px',
                },
            },
        },
    },
    searchControlField: (0, basic_1.applyBase)({
        '.icon': {
            width: '20px',
            height: '20px',
            mt: '-1px',
        },
        input: {
            height: ['45px', '48px'],
            pr: [null, '5px'],
        },
        'input:focus': {
            boxShadow: 'inset 0 -3px 0 0 #E30613',
        },
    }),
    travelDatesWrapper: (0, basic_1.applyBase)({
        position: 'relative',
    }),
    textArea: (0, basic_1.applyBase)({
        wrapper: {
            '.label': {
                pl: '5px',
                color: 'secondary',
                mb: [1, 2],
            },
        },
        input: {
            border: '1px solid',
            borderColor: 'borderColor',
            bg: 'bgInput',
            width: '100%',
            fontSize: [2, 3],
            py: [2, 3],
            px: ['10px', '20px'],
        },
    }),
});
//# sourceMappingURL=inputs.js.map